import { Component, Output, EventEmitter, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { SafeUrl } from '@angular/platform-browser';
import RecordRTC from 'recordrtc';
import { ChatWithBot } from '../../model/rolePlay.model';
import { KeyVaultService } from '../../service/key-vault.service';
import { speechAppConfig } from '../../config/config'; //"./config";
import { ToastrService } from 'ngx-toastr';
import { InteractionService } from '../../service/interaction/interaction.service';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
const speechConfigKey = speechAppConfig.speechSubKey
const speechConfigEndpoint = speechAppConfig.speechEndpoint


@Component({
    selector: 'app-speech-to-text',
    templateUrl: './speech-to-text.component.html',
    styleUrl: './speech-to-text.component.scss',
    standalone: false
})
export class SpeechToTextComponent {
  private recognizer: sdk.SpeechRecognizer;
  public url: SafeUrl | undefined;
  isStart: boolean = false;
  recognizedText: string = '';
  date: any;
  public record: RecordRTC | undefined;
  public recording: boolean = false;
  public error: string | undefined;
  switch: string = 'A';
  chatConversation: ChatWithBot[] = [];
  @Output() contentClicked: EventEmitter<string> = new EventEmitter<string>();
  @Input() isDisabled: boolean = false;
  @Input() position: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' | 'default' = 'default';
  // speechKey: string = 'eb9cd0416cb84cf285e9c615fc32a942';
  speechKey: string;
  endpoint: string;
  speechConfig: any;
  constructor(private readonly keyVaultService: KeyVaultService, private readonly toastr: ToastrService, public intService: InteractionService, private readonly tts: TextToSpeechService) { }

  ngOnInit() {
    let speechLanguage = (sessionStorage.getItem('businessUnitCode') && sessionStorage.getItem('businessUnitCode') === 'HCC') ? 'ja-JP' : 'en-US';
    this.keyVaultService.secrets$.pipe(take(1)).subscribe({
      next: (secrets) => {
        this.speechKey = secrets[speechConfigKey];
        this.endpoint = secrets[speechConfigEndpoint] + `/ai_advisor_stt?business_unit_code=${sessionStorage.getItem('businessUnitCode')}&wwid=${sessionStorage.getItem('userId')}&language=${speechLanguage}`;

        this.speechConfig = sdk.SpeechConfig.fromEndpoint(new URL(this.endpoint));
        this.speechConfig.speechRecognitionLanguage = speechLanguage;
        this.recognizer = new sdk.SpeechRecognizer(this.speechConfig, sdk.AudioConfig.fromDefaultMicrophoneInput());
      },
      error: (error) => {
        console.error('Error fetching speech key', error);
      }
    });
    this.intService.recognize$.subscribe(() => {
      this.startRecognitionAndRecording();
      setTimeout(() => {
        this.stopRecognitionAndRecording();
      }, 1000); // Stop recording after 1 second
    });
    this.intService.isProductSelected.subscribe(() => {
      // this.stopRecognitionAndRecording();
      // setTimeout(() => {
      this.intService.triggerRefreshHeader('');
      // }, 1000);
    });

  }

  startContinuousRecognition(): void {
    this.tts.unmutSpeech();
    this.url = null;
    this.isStart = true;
    this.recognizedText = "";
    this.recognizer.startContinuousRecognitionAsync();
    this.recognizer.recognized = (s, e) => {
      if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
        this.date = new Date();
        this.recognizedText += e.result.text;
        //this.checkResponse(e.result.text);
      }
      // else if (e.result.reason === sdk.ResultReason.NoMatch) {
      //   console.log('No match found.');
      // }
    };
  }

  stopContinuousRecognition(): void {
    this.recognizer.stopContinuousRecognitionAsync(
      () => console.log('Continuous recognition stopped.'),
      (error) => console.error('Error stopping continuous recognition:', error)
    );
    this.isStart = false;
    setTimeout(() => {
      this.checkResponse();
    }, 500)
  }

  initiateRecording() {
    this.recording = true;
    const mediaConstraints = {
      video: false,
      audio: true
    };

    navigator.mediaDevices
      .getUserMedia(mediaConstraints)
      .then(this.successCallback.bind(this))
      .catch(this.errorCallback.bind(this));
  }
  successCallback(stream: MediaStream): void {
    const options = {
      type: 'audio',  // Correct type for audio recording
      mimeType: 'audio/wav',
      numberOfAudioChannels: 1
    };

    // Create a new RecordRTC instance with the stream
    this.record = new RecordRTC(stream, options);
    this.record.startRecording();
  }

  checkRecognizer() {
    setTimeout(() => {
      if (this.recognizer) {
        this.startContinuousRecognition();
        this.initiateRecording();
      } else {
        this.checkRecognizer();
      }
    }, 1000);
  }

  startRecognitionAndRecording() {
    this.checkRecognizer();
  }

  stopRecognitionAndRecording() {
    this.stopContinuousRecognition();
    this.stopRecording();
  }

  stopRecording() {
    this.recording = false;
    if (this.record) {
      this.record.stopRecording(() => {
        const blob = this.record?.getBlob();
        if (blob) {
          this.processRecording(blob);
        }
      });
    }
  }
  processRecording(blob: Blob): void {
    this.url = URL.createObjectURL(blob);
  }

  /**
   * Process Error.
   */
  errorCallback(error: any): void {
    this.error = 'Cannot play audio in your browser';
  }

  checkResponse() {
    this.contentClicked.emit(this.recognizedText);
    // this.date = new Date();
    //let prompt = this.recognizedText;
    // this.pushChatContent(this.recognizedText, 'CS', 'person');
    // this.getResponse(this.recognizedText);
    // this.promptText = "";
    //this.pushChatContent(this.streamSubscription, 'CS', 'bot');
  }

  pushChatContent(content: string, person: string, cssClass: string) {
    const currentTimeStamp = new Date();
    const chatToPush: ChatWithBot = { person: person, response: content, cssClass: cssClass, timestamp: currentTimeStamp };
    this.chatConversation.push(chatToPush);
  }
}
